import { render } from "./ReportRevenueCustomerGroupIndex.vue?vue&type=template&id=4faba8ec&scoped=true"
import script from "./ReportRevenueCustomerGroupIndex.vue?vue&type=script&lang=js"
export * from "./ReportRevenueCustomerGroupIndex.vue?vue&type=script&lang=js"

import "./ReportRevenueCustomerGroupIndex.vue?vue&type=style&index=0&id=4faba8ec&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4faba8ec"]])

export default __exports__